/** Namespace `resale` — PLAT-2026-174 · ADR-054: bán lại dịch vụ đối tác (mở dịch vụ · giá · yêu cầu · hết hạn), bản gốc tiếng Việt. */
export const resale = {
  title: "Bán lại dịch vụ đối tác",
  subtitle:
    "Hub sở hữu toàn bộ vòng đời: mở dịch vụ cho app, gói + giá + chiết khấu, yêu cầu mua mới / gia hạn và báo cáo hết hạn. App chỉ hiển thị và gửi yêu cầu về đây.",
  tabConfig: "Mở bán và giá",
  tabRequests: "Yêu cầu",
  tabExpiry: "Hết hạn",
  loadFailed: "Không đọc được dữ liệu bán lại dịch vụ.",
  saveFailed: "Không lưu được.",
  saved: "Đã lưu.",
  dirOutbound: "Đầu ra (bán ra)",
  dirInbound: "Đầu vào (mua vào)",
  fulfilmentManual: "Nhân viên làm tay",
  fulfilmentAgency: "Kênh đại lý (API)",
  // ── Mở bán ──
  offeringsTitle: "Dịch vụ mở cho app",
  offeringsHint: "Bật « Mở bán » thì khách trong app thấy dịch vụ này (kèm gói và giá bên dưới). Dịch vụ chỉ hiện khi hợp đồng bán của Bube với nhà đó còn hiệu lực.",
  fieldService: "Dịch vụ",
  fieldDirection: "Chiều",
  fieldListed: "Mở bán",
  fieldFulfilment: "Cách xử lý",
  fieldDiscountNew: "Chiết khấu mua mới (%)",
  fieldDiscountRenew: "Chiết khấu gia hạn (%)",
  fieldPriceSource: "Lấy bảng giá của",
  priceSourceSelf: "Chính dịch vụ này",
  fieldNote: "Ghi chú",
  save: "Lưu",
  edit: "Sửa",
  noOfferings: "Chưa mở dịch vụ nào cho app này.",
  listedYes: "Đang mở bán",
  listedNo: "Tắt",
  // ── Gói giá ──
  plansTitle: "Gói và giá công khai",
  plansHint: "Đổi giá = thêm mức mới với ngày hiệu lực mới. Mức đã tới ngày hiệu lực không sửa được (đơn đã chụp giá); muốn dừng bán thì thêm mức mới và bỏ chọn « Đang bán ».",
  fieldPlanCode: "Mã gói",
  fieldPlanName: "Tên gói",
  fieldQuota: "Số hoá đơn",
  fieldTerm: "Thời hạn (tháng)",
  fieldPrice: "Giá công khai (₫)",
  fieldEffective: "Hiệu lực từ (YYYY-MM-DD)",
  fieldActive: "Đang bán",
  addPlan: "Thêm mức giá",
  noPlans: "Chưa có gói nào.",
  unlimited: "Không giới hạn",
  // ── Yêu cầu ──
  requestsTitle: "Hàng chờ yêu cầu mua / gia hạn (mọi app)",
  filterAll: "Tất cả trạng thái",
  empty: "Không có yêu cầu nào.",
  colWhen: "Gửi lúc",
  colApp: "App",
  colCompany: "Công ty",
  colContact: "Người liên hệ",
  colPlan: "Gói",
  colPrice: "Giá",
  colStatus: "Trạng thái",
  kind_new: "Mua mới",
  kind_renew: "Gia hạn",
  priceLine: "{net} (công khai {pub}, giảm {pct}%)",
  status_submitted: "Mới gửi",
  status_in_review: "Đang xem xét",
  status_approved: "Đã duyệt",
  status_fulfilled: "Đã hoàn tất",
  status_rejected: "Từ chối",
  status_cancelled: "Đã huỷ",
  action_in_review: "Nhận xử lý",
  action_approved: "Duyệt",
  action_fulfilled: "Hoàn tất",
  action_retry: "Chạy lại Agency Core",
  action_rejected: "Từ chối",
  action_cancelled: "Huỷ",
  confirmTaxCode: "Gõ lại MST {taxCode} để xác nhận thao tác thật ở nhà cung cấp",
  decidedBy: "Xử lý bởi {who}",
  // ── Hết hạn ──
  expiryTitle: "Báo cáo hết hạn",
  expiryWithin: "Hiện thuê bao hết hạn trong (ngày)",
  expiryEmpty: "Không có thuê bao nào sắp hết hạn hoặc đã hết hạn.",
  colService: "Dịch vụ",
  colTax: "MST",
  colExpires: "Hết hạn",
  colDaysLeft: "Còn lại (ngày)",
  state_active: "Còn hạn",
  state_expiring: "Sắp hết hạn",
  state_expired: "Đã hết hạn",
  taxMatch: "MST khớp hồ sơ công ty",
  taxMismatch: "⚠ MST KHÁC hồ sơ công ty của khách ({code})",
  taxNoProfile: "⚠ Khách chưa khai hồ sơ công ty — không đối chiếu được MST",
  decisionNoteHint: "Ghi chú xử lý (khách THẤY khi từ chối / huỷ)",
  subsTitle: "Ghi nhận thuê bao có sẵn",
  subsHint: "Dành cho khách đã mua ngoài hệ thống. Cùng (workspace, MST, dịch vụ, chiều) thì cập nhật hạn của thuê bao hiện có. Workspace ID lấy ở trang khách hàng của app.",
  subsWorkspace: "Workspace ID",
  subsTax: "MST",
  subsStarts: "Bắt đầu (YYYY-MM-DD)",
  subsExpires: "Hết hạn (YYYY-MM-DD)",
  subsSave: "Ghi nhận thuê bao",
  subsApp: "App",
} as const;
